import { useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "@reach/router";
interface NextTimerResponse {
  success: boolean;
  nextDealTimer?: string;
  error?: string;
}

export const useNextTimer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();
  const dealId = location.pathname?.split("/").filter(Boolean).pop();

  const fetchNextTimer = useCallback(async (): Promise<string | null> => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.get<NextTimerResponse>(
        `/api/get-next-timer?dealId=${dealId || ""}`
      );

      const data = response.data;

      if (data.success && data.nextDealTimer) {
        setIsLoading(false);
        return data.nextDealTimer;
      } else {
        setIsLoading(false);
        throw new Error(data.error || "No next timer found");
      }
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Unknown error occurred";
      setError(errorMessage);
      console.error("Error fetching next timer:", errorMessage);
      setIsLoading(false);
      return null;
    }
  }, []);

  return {
    fetchNextTimer,
    isLoading,
    error,
  };
};
